(function (angular) {
    'use strict';

    angular.module('app')
        .directive('sortableList', sortableList);

    // sortableList.$inject = [];

    function sortableList() {
        function sortableListLink($scope) {
            // defaults
            angular.extend($scope, {
                canRemove: true,
                canAdd: true,
                addButtonLabel: 'New Item',
            }, $scope);

            // methods
            $scope.addItem = addItem;
            $scope.removeItem = removeItem;

            /**
             * Adds a new blank item
             * @return {void}
             */
            function addItem() {
                var newItemTypes = {
                        string: ''
                    },
                    newItem = {};

                angular.forEach($scope.itemTemplate, function (info, key) {
                    newItem[key] = newItemTypes[info.type];
                });

                $scope.ngModel.push(newItem);
            }

            /**
             * Removes an item from the model
             * @param  {object} item - item from ngModel
             * @return {void}
             */
            function removeItem(item) {
                var index = $scope.ngModel.indexOf(item);

                $scope.ngModel.splice(index, 1);
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'directives/sortable-list.html',
            scope: {
                ngModel: '=',
                itemTemplate: '=',
                canAdd: '=?',
                canRemove: '=?',
                addButtonLabel: '@',
            },
            link: sortableListLink
        };
    }

}(angular));
